import * as React from 'react';
import classNames from 'classnames';
import { NavigateFunction } from 'react-router-dom';

import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';

import { Company } from '../../reducers/types';

const styles = require('./styles.pcss');

type Props = {
  company: Company;
  navigate: NavigateFunction;
};

const CompanyTableRow = ({ company, navigate }: Props) => {


  return (
    <TableRow
      className={classNames(styles.clickable, styles.tableRow)}
      key={company.id}
      onClick={() => navigate(`/company/${company.id}`)}
    >
      <TableCell
        className={classNames(styles.tableRowCell)}
        scope="row"
      >
        {company.name}
      </TableCell>
      <TableCell className={classNames(styles.tableRowCell)}>
        {company.primaryDomain}
      </TableCell>
      <TableCell className={classNames(styles.tableRowCell)}>
        {company.organizationShortname ?? ''}
      </TableCell>
      <TableCell className={classNames(styles.tableRowCell)}>
        {company?.agency?.friendlyName ?? ''}
      </TableCell>
      <TableCell className={classNames(styles.tableRowCell)}></TableCell>
    </TableRow>
  );
};

export default CompanyTableRow;
